import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ReactionWowIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps({ ...props, viewBox: "0 0 28 28" })}>
    <rect fill="#0A78BF" height="28" rx="14" width="28" />
    <g filter="url(#filter0_dd_4269_2947)">
      <path
        d="M11.8176 12.8517C13.8472 11.3548 11.2091 7.91135 10.5 7.58337L17.5 7.64189C16.4532 8.18982 14.2531 11.4346 15.8768 12.8517C17.7257 14.4654 9.85677 14.2979 11.8176 12.8517Z"
        fill="#6CAED9"
      />
    </g>
    <path
      d="M16.4725 4.74747C15.7864 3.64981 12.8593 2.6421 11.0298 4.65447C7.80199 4.18333 5.71645 6.46842 6.63428 7.30341C6.37303 8.2718 7.60725 8.22464 9.17879 8.00357C11.7978 9.11688 12.5747 8.63262 13.1121 8.26674C13.5501 8.37184 15.4258 9.23001 16.2831 8.37358C17.2768 8.98919 18.7271 8.69783 19.2924 8.4852C20.5161 8.74837 20.7474 8.26674 21.2102 7.7851C22.39 6.55717 20.4969 5.31182 19.3534 5.86072C19.1247 4.946 17.8447 4.19871 16.4725 4.74747Z"
      fill="#FDFEFE"
    />
    <path
      d="M4.58789 12.1504L4.77246 12.1865L6.125 11.375L7.58301 12.25L9.625 11.375L11.083 12.542L13.125 11.958L15.75 13.125L19.25 11.375L20.5898 12.7148L20.8428 12.6631L21.875 11.375L23.042 11.958L23.625 11.083L24.5 11.958V13.708H24.4922C24.4948 13.8051 24.5 13.9023 24.5 14C24.5 19.799 19.7988 24.5 14 24.5C8.20141 24.4998 3.50098 19.7989 3.50098 14C3.50098 13.6661 3.50173 13.3794 3.50293 13.1279L3.5 13.125V10.792L4.58789 12.1504Z"
      fill="white"
    />
    <ellipse cx="13.7773" cy="20.125" fill="#086099" rx="2.6381" ry="2.04167" />
    <path
      clipRule="evenodd"
      d="M18.6667 17.5C17.7007 17.5 16.9167 16.5861 16.9167 15.4583C16.9167 14.3313 17.7007 13.4166 18.6667 13.4166C19.6334 13.4166 20.4167 14.3313 20.4167 15.4583C20.4167 16.5861 19.6334 17.5 18.6667 17.5Z"
      fill="#086099"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M9.33325 17.5C8.36725 17.5 7.58325 16.5861 7.58325 15.4583C7.58325 14.3313 8.36725 13.4166 9.33325 13.4166C10.3 13.4166 11.0833 14.3313 11.0833 15.4583C11.0833 16.5861 10.3 17.5 9.33325 17.5Z"
      fill="#086099"
      fillRule="evenodd"
    />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="22.4167"
        id="filter0_dd_4269_2947"
        width="23"
        x="2.5"
        y="0.583374"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.12 0"
        />
        <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_4269_2947" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="3" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0 0.00392157 0 0 0 0.14 0"
        />
        <feBlend
          in2="effect1_dropShadow_4269_2947"
          mode="normal"
          result="effect2_dropShadow_4269_2947"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_4269_2947"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
